<template>
  <section id="section-sports" class="games-section sports-frame-section">
    <div class="section-header">
      <div class="section-header__title">
        <h2>{{ $t('games.sportsTitle') }}</h2>
      </div>
    </div>

    <p v-if="loading" class="games-section__status">{{ $t('games.loadingSports') }}</p>
    <p v-else-if="error" class="games-section__status games-section__status--error">{{ error }}</p>

    <div v-else-if="frameUrl" class="sports-frame-wrap">
      <iframe
        class="sports-frame"
        :src="frameUrl"
        :title="$t('games.sportsSubtitle')"
        frameborder="0"
        scrolling="auto"
        allow="fullscreen"
        referrerpolicy="no-referrer-when-downgrade"
      />
    </div>

    <p v-else class="games-section__status">{{ $t('games.sportsPreparing') }}</p>
  </section>
</template>

<script>
export default {
  name: 'BlackGoldSportsFrame',
  props: {
    frameUrl: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  }
}
</script>
